var render = function render(){var _vm=this,_c=_vm._self._c;return _c('job-media-files-selector',{attrs:{"result-as-array":true,"job-id":_vm.jobId,"job-view":_vm.jobView,"input-name":_vm.inputName,"readonly":_vm.readonly},on:{"input":function($event){_vm.selectedFiles = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }